import en from './en.json';
import fi from './fi.json';

const languages = [en, fi];

export default languages;
